import { useContext, createContext } from "react";

import { RetirementContributionsResponseDto } from "enrollment/queries/useRetirementContributionsQuery/utils";
import { BenefitDto } from 'enrollment/queries/useBenefitPlansQuery/types';
import { ElectRequestDto } from "enrollment/features/Plans/PlanCard/types";


type Contribution401kContextType = {
    benefit: BenefitDto;
    enrollmentContextType: string;
    selectedRadio: 'percentage' | 'perPayPeriod' | undefined;
    amountPercentage: number | null;
    eeContribution: number | null;
    retirementContributionsData: RetirementContributionsResponseDto | undefined;
    loading: boolean;
    setSelectedRadio: (value: 'percentage' | 'perPayPeriod') => void;
    setAmountPercentage: (value: number | null) => void;
    setEeContribution: (value: number | null) => void;
    updateElection: (params: ElectRequestDto) => void
    electedRiders: number[];
}

export const Contribution401kContext = createContext<Contribution401kContextType | undefined>(undefined);

export function useContribution401kContext() {
    const context = useContext(Contribution401kContext);
    if (!context) {
        throw new Error('useContribution401kContext must be used within a Contribution401kProvider');
    }
    return context;
};